export default __webpack_public_path__ + "static/media/side_promote.dbe8bde5.svg";